import AddCoTeacher from './AddCoTeacher';
import { AddCoTeacherProps, AddCoTeacherValueProps } from './types';

export type { AddCoTeacherProps, AddCoTeacherValueProps };
export default AddCoTeacher;
